import { CountryAction } from '../actions/action.creators';
import { InitialCountryState } from '../state/state';
import { CountryActionType as actions } from '../actions/actions';
import { CountryState } from '../state/state.interface';

const countries = (state = InitialCountryState, action: CountryAction) => {
    switch (action.type) {
        case actions.GET_LIVE_COUNTRIES:
            return { ...state, gettingLiveCountries: true } as CountryState;
        case actions.GET_LIVE_COUNTRIES_SUCCESS:
            return {
                ...state,
                gettingLiveCountries: false,
                gettingLiveCountriesSuccess: true,
                liveCountries: action.payload
            } as CountryState;
        case actions.GET_LIVE_COUNTRIES_FAILURE:
            return {
                ...state,
                gettingLiveCountries: false,
                gettingLiveCountriesSuccess: false,
                gettingLiveCountriesFailure: action.payload
            } as CountryState;
        default:
            return state;
    }
};

export default countries;
